export default function(state) {
    return {
        user: state.user,
        grades: state.grades,
        sellingMarks: state.sellingMarks
    };
}
  